import { render, staticRenderFns } from "./PretClient.vue?vue&type=template&id=cb0133c8&"
import script from "./PretClient.vue?vue&type=script&lang=js&"
export * from "./PretClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports